import { v4 } from 'uuid';
import {
  dispatchRequestInfo,
  executeTwoStepEventQueries,
  executeTwoStepEventQuery,
} from './execute';
import {
  buildCsvUsageQuery,
  buildUsageQueries,
  fromCsvUsageResponse,
  fromUsageResponse,
  getCsvUsageInfo,
  getUsageInfo,
} from '../converters/usageApiConverter';
import { downloadCsv } from '../utils/common';
import { TABS } from '../constants/navigation';

export const executeUsage = (executeId) => (dispatch, getState) => {
  const state = getState();
  const queries = buildUsageQueries(state);
  const usageInfo = getUsageInfo(state);

  return executeTwoStepEventQueries(queries, executeId, dispatch, getState).then((response) =>
    fromUsageResponse(response, queries, usageInfo)
  );
};

export const executeUsageCsv = () => (dispatch, getState) => {
  const state = getState();
  const query = buildCsvUsageQuery(state);
  const executeId = v4();
  const csvUsageInfo = getCsvUsageInfo(state);

  dispatchRequestInfo(executeId, dispatch, TABS.USAGE.title, [query.eventName], true);

  return executeTwoStepEventQuery(query, executeId, dispatch, getState)
    .then((response) => fromCsvUsageResponse(response, query, csvUsageInfo))
    .then(downloadCsv);
};
